import {useEffect, useState} from "react";

const useScrollerDots = (ref, dependencies = []) => {
    const [dots, setDots] = useState(1);
    const [activeDot, setActiveDot] = useState(0);
    const calculateDots = () => {
        const el = ref.current;
        if (!el) return;
        const pages = Math.ceil(
            el.scrollWidth / el.clientWidth
        );
        setDots(
            pages > 0 ? pages : 1
        );
    };
    const handleScroll = () => {
        const el = ref.current;
        if (!el) return;
        const pageWidth = el.clientWidth;
        const index = Math.round(
            el.scrollLeft / pageWidth
        );
        setActiveDot(index);
    };
    useEffect(() => {
        calculateDots();
        window.addEventListener(
            "resize",
            calculateDots
        );
        return () => {
            window.removeEventListener(
                "resize",
                calculateDots
            );
        };
    }, dependencies);
    return {
        dots,
        activeDot,
        handleScroll,
        refreshDots: calculateDots
    };
};
export default useScrollerDots;